var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09998 11V12.4",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76672 14.6666H11.4334V14C11.4334 13.2666 10.8334 12.6666 10.1001 12.6666H6.10006C5.36672 12.6666 4.76672 13.2666 4.76672 14V14.6666V14.6666Z",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09998 14.6666H12.1",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 10.6667C5.42004 10.6667 3.33337 8.58004 3.33337 6.00004V4.00004C3.33337 2.52671 4.52671 1.33337 6.00004 1.33337H10C11.4734 1.33337 12.6667 2.52671 12.6667 4.00004V6.00004C12.6667 8.58004 10.58 10.6667 8.00004 10.6667Z",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64665 7.76669C3.14665 7.60669 2.70665 7.31336 2.35999 6.96669C1.75999 6.30002 1.35999 5.50002 1.35999 4.56669C1.35999 3.63336 2.09332 2.90002 3.02665 2.90002H3.45999C3.32665 3.20669 3.25999 3.54669 3.25999 3.90002V5.90002C3.25999 6.56669 3.39999 7.19336 3.64665 7.76669Z",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3534 7.76669C12.8534 7.60669 13.2934 7.31336 13.6401 6.96669C14.2401 6.30002 14.6401 5.50002 14.6401 4.56669C14.6401 3.63336 13.9067 2.90002 12.9734 2.90002H12.5401C12.6734 3.20669 12.7401 3.54669 12.7401 3.90002V5.90002C12.7401 6.56669 12.6001 7.19336 12.3534 7.76669Z",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.62dad6603acad25a08499b61c2578369.svg";
export { ForwardRef as ReactComponent };